import React from "react";
import "./serviceWEB.css";
import Topbar from "../../components/Topbar/Topbar";
import Footer from "../../components/Footer/Footer";
import Website from "../../components/Website/Website"

const Serviceweb = () => {
    return (
        <>
            <Topbar />
            <div className="serviceWEB-container">
                <Website/>
                <Footer />
            </div>
        </>
    )
}

export default Serviceweb;